import React from "react";
import TextField from "@material-ui/core/TextField";
import Logo from "../../assets/img/logo.svg";
import { LOGIN, STUDENT, IS_SESSION_ACTIVE } from "../../utils/url-builder";
import { get, post, setTokenOnLogin } from "../../utils/api-authentication";
import {
  EmailValidationError,
  userNameValidationError
} from "../../utils/common-utils";
import {
  setInstituteKneuraId,
  setInstituteId,
  setToken,
  setKneuraId,
  setUserId,
  setClassInfo,
  setusername,
  getToken,
  setNotificationToken
} from "../../utils/authentication-access";
import "../../assets/css/common.scss";
import Snackbar from "@material-ui/core/Snackbar";
import BaseService from "../../store/services/base.service";
import { Mixpanel } from "../../utils/mixpanel";
import { WEBSITE_URL } from "../../config";

class Login extends React.Component {
  constructor(props) {
    super(props);
    Login.context = this;
    this.state = {
      username: "",
      password: "",
      errmsg: " ",
      openerrmsg: false
    };
  }

  componentDidMount() {
    //this.validateUserToken();
  }

  validateUserToken() {
    return new Promise(async (resolve, reject) => {
      try {
        const url = IS_SESSION_ACTIVE.isSessionActive();
        let res = await new BaseService().makeGetRequestGeneric(url);
        this.props.history.replace("/dashboard");

        return resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  }

  onUserNameEnter(event) {
    this.setState({
      username: event.target.value,
      usernameerrorText: "",
      usernameerrorstatus: false
    });
  }

  onPasswordEnter(event) {
    this.setState({
      password: event.target.value,
      passworderrorText: "",
      passworderrorstatus: false
    });
  }

  dashboardPage = () => {
    this.props.history.push("/dashboard");
  };

  forgotPasswordClick = () => {
    this.props.history.push("/forgotpassword");
  };

  signUpClick = () => {
    // this.props.history.push("/signup");
    window.location.replace(WEBSITE_URL);
  };

  static navigateToLogin = () => {
    if (Login.context)
      // Login.context.props.history.push("/login");
      window.location.replace(WEBSITE_URL);
  };

  loginUpClick = async () => {
    let self = this;
    if (this.state.username === "") {
      this.setState({ usernameerrorstatus: true });
      this.setState({ usernameerrorText: "Please enter Email address" });
    } else if (
      EmailValidationError(this.state.username) &&
      userNameValidationError(this.state.username)
    ) {
      this.setState({ usernameerrorstatus: true });
      this.setState({ usernameerrorText: "Invalid EmailId or User Name" });
    } else if (this.state.password === "") {
      this.setState({ passworderrorstatus: true });
      this.setState({ passworderrorText: "Please enter Password" });
    } else {
      const url = LOGIN.login();
      let res = await new BaseService().makePostRequestGeneric(url, {
        email: EmailValidationError(this.state.username)
          ? ""
          : this.state.username.toLowerCase(),
        password: this.state.password,
        role: "learner",
        username: EmailValidationError(this.state.username)
          ? this.state.username
          : ""
      });
      if (res.data) {
        console.log("LOGIN API DATA", res.data);
        sessionStorage.clear();
        this.setState({ data: res.data });
        setKneuraId(res.data.kneura_id);
        setUserId(res.data.userId);
        setInstituteKneuraId(res.data.instituteKneuraId);
        setInstituteId(res.data.instituteId);
        setToken(res.data.access_token);
        setTokenOnLogin(res.data.access_token);
        setusername(res.data.first_name);
        setNotificationToken(res.data.notificationToken);
        Mixpanel.identify(res.data.kneura_id);
        Mixpanel.track("Successful Login");
        this.getAllClasses(res.data.kneura_id, res.data.instituteKneuraId);
      }
    }
  };

  getAllClasses = async (user_id, Inst_id) => {
    const url = STUDENT.getStudentClass();

    let res = await new BaseService().makeGetRequestGeneric(url, {
      access_token: getToken(),
      "Content-Type": "application/json",
      role: "learner",
      user_kneura_id: user_id,
      institute_kneura_id: Inst_id
    });
    if (res.data.length > 0) {
      setClassInfo(res.data[0]);
    }
    this.props.history.push("/dashboard");
  };

  onEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      this.loginUpClick();
    }
  };

  render() {
    return (
      <div>
        <div className="card signin-card">
          <div className="text-left mb-2">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="card-title">Sign in to Kneura</div>
          <p>Please enter your kneura id to proceed.</p>
          <TextField
            id="standard-username"
            label="E-mail address or User Name"
            className="input-field"
            margin="normal"
            value={this.state.username}
            FormHelperTextProps={fixHyperText}
            helperText={this.state.usernameerrorText}
            error={this.state.usernameerrorstatus}
            onChange={this.onUserNameEnter.bind(this)}
            onKeyDown={this.onEnterKeyPress}
          />
          <TextField
            ref="password"
            type="password"
            id="password"
            label="Password"
            className="input-field"
            margin="normal"
            value={this.state.password}
            FormHelperTextProps={fixHyperText}
            helperText={this.state.passworderrorText}
            error={this.state.passworderrorstatus}
            onChange={this.onPasswordEnter.bind(this)}
            onKeyDown={this.onEnterKeyPress}
          />
          <p className="text-secondary hover-text mt-2 text-right hover">
            <button
              className="ButtonLink link-secondary"
              onClick={this.forgotPasswordClick}
            >
              {" "}
              Forgot Password?
            </button>
          </p>
          <button
            className="btn-button-learn mt-2 col-full"
            onClick={this.loginUpClick}
          >
            Sign In
          </button>
          {/* <p className="text-black text-center">Don't have an account?<button className="link ButtonLink" onClick={this.signUpClick}> {' Sign Up >'}</button></p> */}
        </div>

        <Snackbar
          message={this.state.errmsg}
          open={this.state.openerrmsg}
          onClose={() => this.setState({ openerrmsg: false })}
          autoHideDuration={2000}
        />
      </div>
    );
  }
}

const fixHyperText = {
  style: {
    position: "absolute",
    bottom: "-30%"
  }
};

export default Login;
